import { ISelector } from '@omaze/redux';

import { createTooltipSelector } from '../../Tooltip.factories';
import { ITooltipMessage, ITooltipState } from '../../Tooltip.state';

export const selectTooltipMessage: ISelector<ITooltipState, ITooltipMessage> =
    createTooltipSelector((state: ITooltipState): ITooltipMessage | null => {
        return state.message;
    });
